module.exports = __webpack_public_path__ + "icon-search.478ba8ac36fe54cda2e25398ed3e08aa.svg";